import angular from "angular";

angular
    .module('app')
    .component('categoriesControl', {
        template: require('./categories-control.html'),
        controller: ['$http', '$uibModal', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            categories: '<',
        }
    });

function controller($http, $uibModal, ErrorResponseParser, Notifier, $scope) {


    let $ctrl = this;

    $ctrl.$onInit = function () {

    };

    $ctrl.openDeleteForm = function (category, index) {
        $uibModal
            .open({
                component: 'deleteForm',
                resolve: {
                    item: function () {
                        return category;
                    },
                    type: function () {
                        return 'categories';
                    }
                },
                keyboard: false,
                backdrop: 'static',
                size: 'sm'
            })
            .result
            .then(
                function (response) {
                    if (response.status === 500) {
                        Notifier.error(response.data.error, 3)
                    }
                    if (response.status === 200) {
                        Notifier.success(response.data.success, 3);
                        $ctrl.categories.splice(index, 1);
                    }
                }
            );
    }
}